module.exports = __webpack_public_path__ + "img/icon_help.65bd67e2.svg";